module.exports = __webpack_public_path__ + "static/media/Vector-4.11d42567.svg";